import React, { useContext } from "react";
import styled, { ThemeProvider, css } from "styled-components";
import Fade from 'react-reveal/Fade';
import AppContext from '../context/play-url'
import { Link } from "gatsby";

const WrapperContact = styled.div`
  .wrapperContent {
    width: 70%;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    background: transparent linear-gradient(180deg, #e8e8e0 0%, #e8e8e0 100%) 0%
      0% no-repeat padding-box;
    box-shadow: -5px -5px 10px #ffffff, 0px 0px 10px -5px #000000;
    border-radius: 10px;
    opacity: 1;
  }
`;

const LogoProvider = styled.div`
  border-radius: 10px;
  background: ${(props) => props.theme.background};
`;

const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 70px;
  background: transparent linear-gradient(180deg, #e8e8e0 0%, #e8e8e0 100%) 0%
    0% no-repeat padding-box;
  box-shadow: -5px -5px 10px #ffffff, 0px 0px 10px -5px #000000;
  border-radius: 50px;
  padding: 3px;
  margin: 15px;
  user-select: none;
  cursor: pointer;

  @media screen and (max-width: 1200px) {
    margin: 5px;
    width: 210px;
    height: 60px;
  }

  @media screen and (max-width: 768px) {
    margin: 3px;
    width: 190px;
    height: 50px;
  }

  @media screen and (max-width: 640px) {
    margin: 2px;
    width: 140px;
    height: 40px;
  }

  @media screen and (max-width: 576px) {
    margin: 1px;
    width: 110px;
    height: 35px;
  }
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 230px;
  height: 55px;
  background: ${(props) => props.theme.background};
  border-radius: 26px;
  opacity: 1;
  color: ${(props) => props.theme.textBtnColor};
  font-size: 30px;

  @media screen and (max-width: 1200px) {
    width: 200px;
    height: 50px;
    font-size: 20px;
  }

  @media screen and (max-width: 768px) {
    width: 180px;
    height: 40px;
    font-size: 10px;
  }

  @media screen and (max-width: 640px) {
    width: 125px;
    height: 30px;
  }

  @media screen and (max-width: 576px) {
    width: 110px;
    height: 30px;
  }
`;

const textName = css`
  text-align: center;
  font-size: 25px;
  color: ${(props) => props.theme.fontColor};

  @media screen and (max-width: 1200px) {
    font-size: 20px;
  }

  @media screen and (max-width: 768px) {
    font-size: 18px;
  }

  @media screen and (max-width: 640px) {
    font-size: 12px;
  }
`;

const colorTheme = {
  live22: {
    fontColor: "#0396FF",
    textBtnColor: "#ffffff",
    background:
      "transparent linear-gradient(180deg, #0396FF 0%, #0080DB 100%) 0% 0% no-repeat padding-box",
  },
  slotxo: {
    fontColor: "#E40203",
    textBtnColor: "#ffffff",
    background:
      "transparent linear-gradient(180deg, #E40203 0%, #960E10 100%) 0% 0% no-repeat padding-box",
  },
  pgslot: {
    fontColor: "#3DB741",
    textBtnColor: "#ffffff",
    background:
      "transparent linear-gradient(180deg, #28BC7B 0%, #3DB741 100%) 0% 0% no-repeat padding-box",
  },
  joker: {
    fontColor: "#FF12A4",
    textBtnColor: "#ffffff",
    background:
      "transparent linear-gradient(180deg, #FF12A4 0%, #DA0055 100%) 0% 0% no-repeat padding-box",
  },
  ambslot: {
    fontColor: "#FFB503",
    textBtnColor: "#ffffff",
    background:
      "transparent linear-gradient(180deg, #FAEB57 0%, #E59801 100%) 0% 0% no-repeat padding-box",
  },
};

const ContactComponent = ({ data, textBtn, isiFrame, valueKey }) => {
  const { toggleIframe, toggleSetIframeUrl } = useContext(AppContext)

  return (
    <WrapperContact className="w-full mt-5">
      {!isiFrame && data.filter((items) => items.providerName !== 'ambslot').map((items, index) => (
        <ThemeProvider key={index} theme={colorTheme[items.providerName]}>
          <Fade bottom>
            <div className="grid grid-cols-2 p-3 wrapperContent">
              <LogoProvider>
                <img src={items.providerLogo.url} alt="" />
              </LogoProvider>
              <div className="flex items-center justify-center right-side">
                <div>
                  {valueKey !== '/contact' && (
                    <WrapperButton>
                      <Link to={items.providerName === 'live22' ? `${valueKey}` : `/${items.providerName}${valueKey}`}>
                        <Button className="whitespace-nowrap" onClick={() => [toggleIframe(true), toggleSetIframeUrl(items.link)]}>
                          {textBtn}
                        </Button>
                      </Link>
                    </WrapperButton>
                  )}
                  {valueKey === '/contact' && (
                    <WrapperButton>
                      <a href={items.link} target="_blank" rel="noreferrer" >
                        <Button className="whitespace-nowrap">
                          {textBtn}
                        </Button>
                      </a>
                    </WrapperButton>
                  )}
                  <div css={textName}>{items.title}</div>
                </div>
              </div>
            </div>
          </Fade>
        </ThemeProvider>
      ))}
    </WrapperContact>
  );
};

export default ContactComponent;
